import { useBillingSettings } from '@/hooks/settings/billing/useBillingSettings';
import { normalizeHexColor } from '@/lib/forms/public-settings';

/**
 * The company colour an intake form without its own falls back to: invoice
 * branding's primary colour, read the way the public form page reads it (a
 * short `#abc` counts, as `#aabbcc`). Null when it is unset or cannot be read
 * (no company:view), so callers keep the default theme. Pass `enabled: false`
 * when no colour is needed.
 */
export function useCompanyBrandColor(enabled = true): string | null {
  const { data } = useBillingSettings({ enabled });
  return normalizeHexColor(expandShortHex(data?.invoices.branding.primaryColor));
}

/** "#abc" → "#aabbcc", as the server's public company contact resolver does. */
function expandShortHex(value: unknown): unknown {
  if (typeof value !== 'string') return value;
  const hex = value.trim();
  return /^#[0-9a-f]{3}$/i.test(hex) ? `#${[...hex.slice(1)].map((c) => c + c).join('')}` : hex;
}
